/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const External: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M20.9998 20.9998H2.99975V2.99975H9.99975V0.99975H1.99975C1.86634 0.99173 1.73274 1.0121 1.60778 1.05952C1.48282 1.10694 1.36934 1.18032 1.27483 1.27483C1.18032 1.36934 1.10694 1.48282 1.05952 1.60778C1.0121 1.73274 0.99173 1.86634 0.99975 1.99975V21.9998C0.99173 22.1332 1.0121 22.2668 1.05952 22.3917C1.10694 22.5167 1.18032 22.6302 1.27483 22.7247C1.36934 22.8192 1.48282 22.8926 1.60778 22.94C1.73274 22.9874 1.86634 23.0078 1.99975 22.9998H21.9998C22.1332 23.0078 22.2668 22.9874 22.3917 22.94C22.5167 22.8926 22.6302 22.8192 22.7247 22.7247C22.8192 22.6302 22.8926 22.5167 22.94 22.3917C22.9874 22.2668 23.0078 22.1332 22.9998 21.9998V13.9997H20.9998V20.9998Z'
      fill='currentColor'
    />
    <path d='M13.999 1L17.793 4.793L12.293 10.293L13.707 11.707L19.207 6.207L23 10V1H13.999Z' fill='currentColor' />
  </React.Fragment>
)
